import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as _ from 'lodash';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { NgIf, NgStyle, NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-hierarhy-filter-button',
    templateUrl: './hierarhy-filter-button.component.html',
    styleUrl: './hierarhy-filter-button.component.scss',
    imports: [NgIf, NgStyle, NgFor, TranslateModule]
})

export class HierarhyFilterButtonComponent implements OnInit, AfterViewInit {
  isHierarchyFilterInitialised: boolean = false;
  isHierarchyInitializing: boolean = true;
  isDropdownOpen: boolean = false;

  loggedInUserLevel;
  project_id;

  loggedInUserValues;
  isHierarchyFilterEnabled: boolean = true
  isAddfilterBtnEnabled: boolean = true;
  isHierarchFilterActive: boolean = false;
  manager_type: any = null;
  access_key: any = null;
  selectedHierarchyValue: string = ''
  defaultAccess: any = {};
  mappedHierarchyLevelNames: any = {};
  globalHierarchyLevels = {};
  hierarchyMapping: any = []
  isHierarchFilterHidden: boolean = false
  constructor(private _filterService: GlobalFilterService, private _helpers: HelpersService, private _accountService: AccountsService) {
    this._filterService.globalFilterState$.subscribe(() => {
      this.toggleActiveState();
    })
    this._filterService.hideHierarchyFilter.subscribe((flag) => {
      this.isHierarchFilterHidden = (flag == true) ? true : false;
    })
  }

  ngOnInit(): void {
    this.initHierarchyFilter();
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event:any) => {
      const element = document.getElementById('hierarchy-value-selector');
      if(element && event.target != element && !element.contains(event.target)){
        this.isDropdownOpen = false;
      }
      

    });
  }
  selectHierarchyValue(event: any): void {
    if (event) event.preventDefault();
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false
    } else {
      this.isDropdownOpen = true;
    }
    // this.isDropdownOpen = !;
    // if (this.isDropdownOpen) {
    //   document.addEventListener('click', this.handleClickOutside);
    // } else {
    //   document.removeEventListener('click', this.handleClickOutside);
    // }
  }
  // Open applied global hierarchy filter on click
  openGlobalFilterSideBar(event: any, action?: string) {
    if (event) event.preventDefault();
    const element = document.getElementById('hierarchy-value-selector')
    if(element  && event.target == element &&  element.contains(event.target)){
      
      if (action == 'select' && event && event.target && event.target.value) {
        this.isDropdownOpen = false;
        const globalFilter = this._filterService.getAppliedFilters()
        if (globalFilter && globalFilter.by_hierarchy_drilldown) {
          let appliedhierarchy = globalFilter.by_hierarchy_drilldown;
          if (appliedhierarchy[0].value != event.target.value) {
            appliedhierarchy[0].value = event.target.value;
            const data = { 'by_hierarchy_drilldown': appliedhierarchy };
            const hierarchyStack = this._filterService.getHierarchyStack(appliedhierarchy);
            this._filterService.setValuesForGlobalUse({ globalFilter: data, type: 'applied_hierarchy_filter' });
            this._helpers.setHierarchyStack(hierarchyStack);
          }
        }
      }
    } else {
      this.renderGlobalFilter()
    }
  }

  renderGlobalFilter() {
    var values = this.mappedHierarchyLevelNames;
    for (let key in values) {
      if (key >= this.loggedInUserLevel) {
        this.globalHierarchyLevels[key] = values[key];
      }
    }

    let tabData: any = {
      hierarchyLevels: this.globalHierarchyLevels,
      project_id: this.project_id,
      tabName: "by_hierarchy",
      filterType: "hierarchy",
      isHierarchyFilterEnabled: this.isHierarchyFilterEnabled
    }
    // Hierarchy block click event from header & prevent displaying By Hierarchy from side bar global filter
    if ((this.manager_type == 3 && this.loggedInUserLevel == 'touchpoints') || (this.manager_type == 2 && this.access_key == undefined)) {
      tabData.isHierarchyFilterEnabled = false;
    }
    this._filterService.updateFilterVisiblity(tabData);
    // Here need to pass selected option if user have multi value access
    this._filterService.openGlobalFilterPanel(tabData);

  }

  initHierarchyFilter() {
    this.isHierarchyInitializing = true;
    // Call service to get logged in manager default access
    this._filterService.getDefaultAccess((parameter) => {
      this.manager_type = _.get(parameter, 'manager_type');
      this.access_key = _.get(parameter, 'access_key');
      if (!parameter || parameter == undefined) {
        console.warn('Error Here, have to handle it, You dont have project level access'); // #todo
      } else {
        if (parameter && parameter['project_id'] && parameter.manager_type != 3) {
          this.project_id = parameter['project_id'];
          // Get brand details
          this.getBrandDetails(parameter['project_id'], (response: any) => {
            const isSingleTouchpoint: boolean = (_.hasIn(response, 'data.brand.is_single_touchpoint_setup') && _.get(response, 'data.brand.is_single_touchpoint_setup') == true) ? true : false;
            const brandDetail = _.get(response, 'data.brand')
            if (response && response.code == 0 && isSingleTouchpoint && parameter.access_key != undefined) {
              // Store logged in manager level and values
              if (!this.isHierarchyFilterInitialised) {
                this.loggedInUserLevel = Object.keys(parameter.access_key)[0];
                this.loggedInUserValues = parameter.access_key[this.loggedInUserLevel].values;
                if (this.selectedHierarchyValue == '') {
                  this.selectedHierarchyValue = this.loggedInUserValues[0]
                }
              }
              this._filterService.setMappedHierarhcyLevels(brandDetail, (data) => {
                this.mappedHierarchyLevelNames = data.mappedHierarchyLevelNames;
                this.hierarchyMapping = data.hierarchyMapping
                this.defaultAccess = {
                  "key": this.loggedInUserLevel,
                  "label": this.mappedHierarchyLevelNames[this.loggedInUserLevel],
                  "options": this.loggedInUserValues,
                  "value": this.selectedHierarchyValue,
                  "enabled": true
                }
                if (data && data.hierarchyMapping && data.hierarchyMapping.length) {
                  const levelIndex = _.findIndex(data.hierarchyMapping, { key: this.loggedInUserLevel })
                  if (levelIndex == data.hierarchyMapping.length - 1) {
                    this.isHierarchyFilterEnabled = false;
                    this._filterService.updateFilterVisiblity({ isHierarchyFilterEnabled: false });
                  } else {
                    this.isHierarchyFilterEnabled = true;
                    this._filterService.updateFilterVisiblity({ isHierarchyFilterEnabled: true });
                  }
                }
                this.isHierarchyInitializing = false;
              })
            } else {
              this.setDefaultTouchpointLevel(parameter)
            }
          })
        } else {
          this.setDefaultTouchpointLevel(parameter)
        }
      }
    });
  }

  getBrandDetails(project_id: string, cb: any) {
    const brandDetails = _.get(Helpers, 'brandDetails', {})
    if (brandDetails && brandDetails['_id'] && brandDetails['_id'] == project_id) {
      // console.log("No need to call APIKKKKK")
      const response = {};
      response['code'] = 0;
      response['data'] = {}
      response['data']['brand'] = brandDetails;
      response['data']['code'] = 0;
      cb(response)
    } else {
      this._accountService.getBrandDetail(project_id).subscribe((result: any) => {
        if (result && result.code == 0) {
          if (result.data && result.data.brand) {
            cb(result);
          }
        } else {
          cb({})
        }
      });
    }
  }

  toggleActiveState() {
    this.isHierarchyInitializing = true;
    let global_filter_data = this._filterService.getAppliedFilters();
    // Draw active default access or Applied filter
    if ((global_filter_data && global_filter_data['by_hierarchy_drilldown']) || (global_filter_data && global_filter_data['by_hierarchy_level_and_value'])) {
      let hiearchyFilter = (global_filter_data['by_hierarchy_drilldown']) ? global_filter_data['by_hierarchy_drilldown'] : global_filter_data['by_hierarchy_level_and_value'];
      if (global_filter_data['by_hierarchy_drilldown'] && hiearchyFilter && hiearchyFilter.length) {
        this.defaultAccess = hiearchyFilter[0]
        const levelIndex = _.findIndex(this.hierarchyMapping, { key: this.defaultAccess.key })
        if (levelIndex == this.hierarchyMapping.length - 1) {
          this.isHierarchyFilterEnabled = false;
          this._filterService.updateFilterVisiblity({ isHierarchyFilterEnabled: false });
        } else {
          this.isHierarchyFilterEnabled = true;
          this._filterService.updateFilterVisiblity({ isHierarchyFilterEnabled: true });
        }
      }
      if (hiearchyFilter && hiearchyFilter.length > 1) {

        const hierarchyLevel2 = hiearchyFilter[1];
        if (hierarchyLevel2 && hierarchyLevel2.value != 'All' && hierarchyLevel2.value != "ALL") {
          this.isHierarchFilterActive = true;
        } else {
          this.isHierarchFilterActive = false;
        }
      } else if ('by_hierarchy_level_and_value' in global_filter_data && hiearchyFilter && hiearchyFilter.value != 'All' && hiearchyFilter.value != 'ALL') {
        this.isHierarchFilterActive = true;
        this.isHierarchyInitializing = false;
      } else {
        if (hiearchyFilter && hiearchyFilter.length) {
          this.loggedInUserLevel = _.get(hiearchyFilter, '0.key', this.loggedInUserLevel)
          this.selectedHierarchyValue = _.get(hiearchyFilter, '0.value', this.selectedHierarchyValue)
          this.loggedInUserValues = _.get(hiearchyFilter, '0.options', [this.selectedHierarchyValue]);
        }
        this.isHierarchFilterActive = false;
        this.isHierarchyInitializing = false;
      }
    }

    this.isHierarchyInitializing = false;
  }

  // Need to implement hierarhcy fallback for manager_type:3 or static project
  setDefaultTouchpointLevel(parameter) {
    this.project_id = parameter['project_id'];
    this.mappedHierarchyLevelNames["touchpoints"] = "Touchpoints";
    this.loggedInUserLevel = "touchpoints"
    this.loggedInUserValues = ["All Touchpoints"]
    this.isHierarchyInitializing = false;
    this.isHierarchyFilterEnabled = false;
    this._filterService.updateFilterVisiblity({ isHierarchyFilterEnabled: false });
  }

  updateHierarchyFilter(hierarchyValue: any, event: any) {
    event.stopPropagation();
    this.selectedHierarchyValue = hierarchyValue;
    this.isDropdownOpen = false;
    let hierarchyFilter: any = [];
    // Reset with default hierarchy
    hierarchyFilter.push(this.defaultAccess);
    if (hierarchyFilter && hierarchyFilter.length) {
      hierarchyFilter[0].value = this.selectedHierarchyValue;
      hierarchyFilter = _.map(hierarchyFilter, (object: any, index: number) => {
        if (index == 0) {
          object.enabled = true
          return object
        } else if (index == 1) {
          object.options = ["ALL"],
            object.value = "ALL"
          object.enabled = true
        } else {
          object.options = ["ALL"],
            object.value = "ALL"
          object.enabled = false
        }
      })
      let hierarchyStack = this._filterService.getHierarchyStack(hierarchyFilter);
      this._filterService.setValuesForGlobalUse({ globalFilter: { 'by_hierarchy_drilldown': Helpers.deepClone(hierarchyFilter) }, type: 'applied_hierarchy_filter' });
      this._helpers.setHierarchyStack(hierarchyStack);
    }
  }
  handleClickOutside = (event: MouseEvent) => {
    // this.isDropdownOpen = false;
  };
  ngOnDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
